import React from "react";

import { EditorView } from "prosemirror-view";

import { showFeatureModal } from "~/billing";
import type { AttendeeAttrs } from "~/common/Attendees";
import { createWorkspaceToast } from "~/lib/guestUserUtils";
import { getContext } from "~/lib/prose/plugins/context";
import SelectKeyResult from "~/lib/prose/plugins/objectives/SelectKeyResult";
import { __globalModalContext } from "~/ui/modals";

export default function slashHandler(view: EditorView): void {
	const context = getContext(view.state);
	const { userId } = context;
	const attendee: AttendeeAttrs | undefined = context?.participants?.find((u: AttendeeAttrs) => u.id === userId);
	if (attendee?.isGuest) {
		createWorkspaceToast({ closeOnClick: true, autoClose: 15000 });
		return;
	}
	if (context.billing && !context.billing?.hasAccessToObjectives) {
		showFeatureModal("objectives");
		return;
	}

	__globalModalContext?.open(({ close }) => <SelectKeyResult view={view} close={close} />);
}
